import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { crmIntegrations, getIntegrations } from '../utility/urls';
@Injectable({
  providedIn: 'root'
})
export class IntegrationsService {
  constructor(
    private http: HttpClient
  ) { }
  getIntegrations(): Observable<any> {
    return this.http.get(environment.rediApi + crmIntegrations + getIntegrations);
  }
  postFormDataIntegration(integrationId: number, data: any): Observable<any> {
    let formData = {
      data
    }
    return this.http.post(environment.rediApi + crmIntegrations + getIntegrations, {
      id: integrationId,
      formdata: formData,
    });
  }
}